import { Controller } from "@hotwired/stimulus"

export default class VideoLabFormController extends Controller {
  static targets = [
    "modeInput",
    "modePanel",
    "modeTab",
    "durationSelect",
    "durationWarning",
    "loopTypeInput",
    "secondFrameInput",
    "secondFrameLabel",
    "costEstimate",
    "returnPromptSection",
  ]

  switchMode(event) {
    event.preventDefault()
    const mode = event.currentTarget.dataset.mode

    this.modeInputTarget.value = mode

    this.modePanelTargets.forEach((panel) => {
      panel.classList.toggle("hidden", panel.dataset.mode !== mode)
    })

    this.modeTabTargets.forEach((tab) => {
      const isActive = tab.dataset.mode === mode
      tab.classList.toggle("border-indigo-500", isActive)
      tab.classList.toggle("text-indigo-600", isActive)
      tab.classList.toggle("border-transparent", !isActive)
      tab.classList.toggle("text-gray-500", !isActive)
    })

    this.enforceDurationForMode(mode)
  }

  changeLoopType(_event) {
    const selected = this.loopTypeInputTargets.find((input) => input.checked)
    const loopType = selected?.value || ""

    if (this.hasSecondFrameInputTarget) {
      if (loopType === "simple") {
        this.secondFrameInputTarget.classList.add("hidden")
      } else {
        this.secondFrameInputTarget.classList.remove("hidden")
      }
    }

    if (this.hasSecondFrameLabelTarget) {
      this.secondFrameLabelTarget.textContent =
        loopType === "round_trip" ? "Mid Frame" : "Last Frame"
    }

    if (this.hasReturnPromptSectionTarget) {
      this.returnPromptSectionTarget.classList.toggle(
        "hidden",
        loopType !== "round_trip"
      )
    }
  }

  enforceDurationForMode(mode) {
    if (!this.hasDurationSelectTarget) return

    if (mode === "text_to_video_with_references") {
      this.durationSelectTarget.value = "8"
      this.durationSelectTarget.disabled = true
      if (this.hasDurationWarningTarget) {
        this.durationWarningTarget.classList.remove("hidden")
      }
    } else {
      this.durationSelectTarget.disabled = false
      if (this.hasDurationWarningTarget) {
        this.durationWarningTarget.classList.add("hidden")
      }
    }
  }
}
